var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsername(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 15") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7528\\u6237\\u5217\\u8868\\u9875-copy-17",
    transform: "translate(-48.000000, -340.000000)",
    fill: "#A0A7B4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9-Copy-2",
    transform: "translate(35.000000, 325.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(13.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,14.4230769 C11.1421356,14.4230769 13.75,14.4230769 15,14.4230769 C15,14.4230769 15,13.7647833 15,12.4481961 L14.9999875,12.4481961 C14.9999875,12.1440945 14.8616082,11.8565172 14.6239706,11.6667643 C12.5901526,10.0427676 10.2154957,9.23076923 7.5,9.23076923 C4.78451071,9.23076923 2.40985864,10.0427638 0.37604379,11.6667529 L0.37603068,11.6667364 C0.138384364,11.8564956 2.62096765e-14,12.144083 2.28705943e-14,12.4481954 C7.65717378e-15,13.7647831 0,14.4230769 0,14.4230769 C0,14.4230769 2.85786438,14.4230769 7,14.4230769 Z",
    id: "Oval-4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    cx: 7.44230769,
    cy: 3.98076923,
    r: 3.98076923
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsername);
export default __webpack_public_path__ + "static/media/username.223a02a357c08d1d1b233f0465677e80.svg";
export { ForwardRef as ReactComponent };